// 迁移
document.addEventListener("DOMContentLoaded", function () {
  // 分类导航
  $(".software-nav-contianer .category-item").on('click', (e) => {
    /** @type {HTMLElement} */
    const el = e.currentTarget;
    const $el = $(el);
    const title = el.querySelector("p").getAttribute("data-title");
    if (el.classList.contains("active")) return;
    $el.addClass('active').siblings().removeClass('active');
    const containerList = document.querySelectorAll("[data-download-category-container]");
    for (const container of containerList) {
      if (title?.toLowerCase() == container.getAttribute("data-title")?.toLowerCase()) {
        $(container).parents(".shopify-section").addClass('active').siblings().removeClass('active');
        break;
      }
    }
    document.querySelector("[data-category-name]").innerHTML = el.querySelector("[data-title]").getAttribute("data-title");
    // search();
  });
  // 显示首组分类
  document.querySelector(".software-sets>div:first-child").classList.add("active");

  let suppressProductOpenUntil = 0;

  // 展示产品下载项弹窗
  function openWindow () {
    $("[data-download-category-product-item]").on("click", (e) => {
      if (Date.now() < suppressProductOpenUntil) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (e.target && e.target.closest(".download-static-variants")) {
        return;
      }
      if (e.target && e.target.closest("[data-download-category-notice]")) {
        return;
      }
      /** @type {HTMLElement} */
      const el = e.currentTarget;
      $(el).siblings().removeClass("active selected");
      el.classList.add("active", "selected");
    });
  }

  openWindow()
  

  // 关闭弹窗
  function closeWindow () {
    $("[data-download-category-close]").on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $(e.currentTarget).closest("[data-download-category-product-item]").removeClass("active");
      suppressProductOpenUntil = Date.now() + 500;
      if (document.activeElement && document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    });
  
    document.querySelector("#software-category-search-button").addEventListener("click", search);
  
    document.querySelector("#software-category-search-text").addEventListener("keydown", (e) => {
      if (e.keyCode == 13) {
        document.querySelector("#software-category-search-button").click();
      }
    });
  }

  closeWindow()
  

  /** 搜索 */
  function search() {

    const val = document.querySelector("#software-category-search-text").value?.toUpperCase() ?? "";
    const items = document.querySelectorAll(".shopify-section [data-download-category-product-item]");
    for (const item of items) {
      const title = item.getAttribute("data-product-title").toUpperCase();
      if (title.indexOf(val.toUpperCase()) !== -1) {
        $(item).show();
        $(item).removeAttr('hide')
        $(item).attr('show', 'show')
      } else {
        $(item).hide();
        $(item).removeAttr('show')
        $(item).attr('hide', 'hide')
      }
    }

    if ($('#software-category-search-text').val().trim() !== '') {
      $('.download-search-content ul').empty();
      $('.software-sets .shopify-section').removeClass('active')
      $('.download-search-content').addClass('active')
      $('.category-item').removeClass('active')
  
      $('.download-item').each(function() {
          var display = $(this).attr('show')
    
          if(display === 'show') {
            var itemContent = $(this).prop('outerHTML');
            $('.download-search-content ul').append(itemContent);
          }
    
      })
  
      openWindow()
      closeWindow()
    } else {
      $('.download-search-content ul').empty();
    }
   

  }

  /** 
   * 分类导航active状态 - 溢出时滚动到active项
   *  */
  function scrollToActiveNav() {
    const container = document.querySelector('.software-nav__item-list ul');
    const activeItem = container?.querySelector('.category-item.active');
    if (!container || !activeItem) return;
    const containerWidth = container.offsetWidth;
    const itemLeft = activeItem.offsetLeft;
    const itemWidth = activeItem.offsetWidth;
    const scrollLeft = itemLeft - containerWidth / 2 + itemWidth / 2;
    const maxScroll = container.scrollWidth - container.clientWidth;
    const finalScroll = Math.max(0, Math.min(scrollLeft, maxScroll));
    container.scrollTo({
      left: finalScroll,
      behavior: 'smooth'
    });
  }

  // 👇 监听 active 变化
  function observeActiveChange() {
    const container = document.querySelector('.software-nav__item-list ul');
    if (!container) return;
    const observer = new MutationObserver(() => {
      scrollToActiveNav();
    });
    observer.observe(container, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }
  observeActiveChange();
  scrollToActiveNav(); // 初始也滚一次

  const SOFTWARE_NAV_SEARCH_MIN_PX = 200;
  const SOFTWARE_NAV_SINGLE_ROW_GAP_PX = 60;
  const SOFTWARE_NAV_LIST_ITEM_GUTTER_PX = 20;

  function measureSoftwareNavListRowWidthPx(ul) {
    if (!ul) return 0;
    const items = ul.querySelectorAll(':scope > li.category-item');
    let w = 0;
    items.forEach((li, i) => {
      w += li.offsetWidth;
      if (i > 0) w += SOFTWARE_NAV_LIST_ITEM_GUTTER_PX;
    });
    return w;
  }

  function updateSoftwareNavStackLayout() {
    const row = document.querySelector(
      '.software-nav-contianer .software-nav__main-row'
    );
    const itemList = row?.querySelector('.software-nav__item-list');
    if (!row || !itemList) return;

    if (window.matchMedia('(max-width: 589px)').matches) {
      row.classList.remove('software-nav__main-row--stack-search');
      return;
    }

    const ul = itemList.querySelector('ul');
    const listIntrinsic =
      measureSoftwareNavListRowWidthPx(ul) ||
      (ul ? ul.scrollWidth : itemList.scrollWidth);
    const rowW = row.clientWidth;
    const needsStack =
      rowW + 0.5 <
      listIntrinsic + SOFTWARE_NAV_SINGLE_ROW_GAP_PX + SOFTWARE_NAV_SEARCH_MIN_PX;

    row.classList.toggle('software-nav__main-row--stack-search', needsStack);
  }

  let softwareNavStackLayoutRaf = 0;
  function scheduleSoftwareNavStackLayout() {
    if (softwareNavStackLayoutRaf) return;
    softwareNavStackLayoutRaf = requestAnimationFrame(() => {
      softwareNavStackLayoutRaf = 0;
      updateSoftwareNavStackLayout();
    });
  }

  updateSoftwareNavStackLayout();
  requestAnimationFrame(updateSoftwareNavStackLayout);

  window.addEventListener('resize', scheduleSoftwareNavStackLayout);
  window
    .matchMedia('(max-width: 589px)')
    .addEventListener('change', scheduleSoftwareNavStackLayout);

  const __navMainRow = document.querySelector(
    '.software-nav-contianer .software-nav__main-row'
  );
  if (typeof ResizeObserver !== 'undefined' && __navMainRow) {
    const navRo = new ResizeObserver(scheduleSoftwareNavStackLayout);
    navRo.observe(__navMainRow);
    const il = __navMainRow.querySelector('.software-nav__item-list');
    if (il) navRo.observe(il);
    const ull = il?.querySelector('ul');
    if (ull) navRo.observe(ull);
  }

  /** 
   * 分页 
   * */
    class Pagination {
      constructor(container) {
        if (!container) return;

        this.header = document.querySelector('.section-header');
        this.container = container;
        this.list = container.querySelector('ul');
        this.items = Array.from(this.list.children);
        this.pagination = container.closest('.shopify-section')?.querySelector('.pagination');

        this.currentPage = 1;
        this.perPage = this.getPerPage();

        this.init();
        window.addEventListener('resize', this.onResize.bind(this));
      }

      getPerPage() {
        const w = window.innerWidth;
        if (w > 1200) return 4 * 6;
        if (w > 750) return 3 * 6;
        return 2 * 6;
      }

      onResize() {
        const newPerPage = this.getPerPage();
        if (newPerPage !== this.perPage) {
          this.perPage = newPerPage;
          this.currentPage = 1;
          this.render();
        }
      }

      init() {
        this.render();
      }

      render() {
        this.totalPage = Math.ceil(this.items.length / this.perPage);

        this.items.forEach((item, index) => {
          const start = (this.currentPage - 1) * this.perPage;
          const end = start + this.perPage;

          item.style.display = index >= start && index < end ? '' : 'none';
        });
        this.scrollToTop();
        this.renderPagination();
      }

      scrollToTop() {
        const rect = this.container.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        const headerOffset = (this.header && this.header.offsetHeight) || 0;

        const targetPosition = rect.top + scrollTop - headerOffset;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }

      renderPagination() {
        if (this.totalPage <= 1) {
          this.pagination.innerHTML = '';
          return;
        }

        let html = '';

        // prev
        html += `<button class="prev" ${this.currentPage === 1 ? 'disabled' : ''}>
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="30" viewBox="0 0 6 30" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.35311 19.3541C5.39967 19.3077 5.43661 19.2525 5.46182 19.1918C5.48703 19.131 5.5 19.0659 5.5 19.0001C5.5 18.9344 5.48703 18.8693 5.46182 18.8085C5.43661 18.7478 5.39967 18.6926 5.35311 18.6461L1.70611 15.0001L5.35311 11.3541C5.44699 11.2603 5.49974 11.1329 5.49974 11.0001C5.49974 10.8674 5.44699 10.74 5.35311 10.6461C5.25922 10.5523 5.13188 10.4995 4.99911 10.4995C4.86633 10.4995 4.73899 10.5523 4.64511 10.6461L0.645106 14.6461C0.598543 14.6926 0.5616 14.7478 0.536394 14.8085C0.511187 14.8693 0.498213 14.9344 0.498213 15.0001C0.498213 15.0659 0.511187 15.131 0.536394 15.1918C0.5616 15.2525 0.598543 15.3077 0.645106 15.3541L4.64511 19.3541C4.69155 19.4007 4.74673 19.4376 4.80747 19.4629C4.86822 19.4881 4.93334 19.501 4.99911 19.501C5.06487 19.501 5.12999 19.4881 5.19074 19.4629C5.25149 19.4376 5.30666 19.4007 5.35311 19.3541Z" fill="currentColor"/>
          </svg>
        </button>`;

        const pages = this.getPages();

        pages.forEach(p => {
          if (p === '...') {
            html += `<span class="ellipsis">...</span>`;
          } else {
            html += `<button class="page ${p === this.currentPage ? 'active' : ''}" data-page="${p}">${p}</button>`;
          }
        });

        // next
        html += `<button class="next" ${this.currentPage === this.totalPage ? 'disabled' : ''}>
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="30" viewBox="0 0 6 30" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.35311 19.3541C5.39967 19.3077 5.43661 19.2525 5.46182 19.1918C5.48703 19.131 5.5 19.0659 5.5 19.0001C5.5 18.9344 5.48703 18.8693 5.46182 18.8085C5.43661 18.7478 5.39967 18.6926 5.35311 18.6461L1.70611 15.0001L5.35311 11.3541C5.44699 11.2603 5.49974 11.1329 5.49974 11.0001C5.49974 10.8674 5.44699 10.74 5.35311 10.6461C5.25922 10.5523 5.13188 10.4995 4.99911 10.4995C4.86633 10.4995 4.73899 10.5523 4.64511 10.6461L0.645106 14.6461C0.598543 14.6926 0.5616 14.7478 0.536394 14.8085C0.511187 14.8693 0.498213 14.9344 0.498213 15.0001C0.498213 15.0659 0.511187 15.131 0.536394 15.1918C0.5616 15.2525 0.598543 15.3077 0.645106 15.3541L4.64511 19.3541C4.69155 19.4007 4.74673 19.4376 4.80747 19.4629C4.86822 19.4881 4.93334 19.501 4.99911 19.501C5.06487 19.501 5.12999 19.4881 5.19074 19.4629C5.25149 19.4376 5.30666 19.4007 5.35311 19.3541Z" fill="currentColor"/>
          </svg>
        </button>`;

        this.pagination.innerHTML = html;

        this.bindEvents();
      }

      getPages() {
        const total = this.totalPage;
        const current = this.currentPage;
        const delta = 1;

        const pages = [];

        let left = current - delta;
        let right = current + delta;

        if (left <= 2) {
          left = 2;
          right = 2 + delta * 2;
        }

        if (right >= total - 1) {
          right = total - 1;
          left = total - 1 - delta * 2;
        }

        pages.push(1);

        if (left > 2) {
          pages.push('...');
        }

        for (let i = left; i <= right; i++) {
          if (i > 1 && i < total) {
            pages.push(i);
          }
        }

        if (right < total - 1) {
          pages.push('...');
        }

        if (total > 1) {
          pages.push(total);
        }

        return pages;
      }

      bindEvents() {
        this.pagination.onclick = (e) => {
          const page = e.target.dataset.page;

          if (page) {
            this.currentPage = Number(page);
          }

          if (e.target.classList.contains('prev') || e.target.closest('button')?.classList.contains('prev')) {
            this.currentPage--;
          }

          if (e.target.classList.contains('next') || e.target.closest('button')?.classList.contains('next')) {
            this.currentPage++;
          }

          this.render();
        };
      }
    }

    document.querySelectorAll('[data-download-category-container]').forEach(container => {
      new Pagination(container);
    });

  /** 侧栏 sticky 顶部偏移：导航显示时留出高度，隐藏时为 0 */
  (function initDownloadSidebarStickyOffset() {
    const header = document.querySelector('.section-header');
    const stickyHeader = document.querySelector('sticky-header');
    if (!header) return;

    const isAlwaysSticky =
      stickyHeader &&
      (stickyHeader.getAttribute('data-sticky-type') === 'always' ||
        stickyHeader.getAttribute('data-sticky-type') === 'reduce-logo-size');

    function updateOffset() {
      const isRevealed =
        isAlwaysSticky ||
        (header.classList.contains('shopify-section-header-sticky') &&
          !header.classList.contains('shopify-section-header-hidden'));

      const offset = isRevealed ? header.offsetHeight : 0;
      document.documentElement.style.setProperty('--dynamic-header-height', `${offset}px`);
    }

    updateOffset();
    window.addEventListener('scroll', updateOffset, { passive: true });
    window.addEventListener('resize', updateOffset);

    const observer = new MutationObserver(updateOffset);
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  })();

});